import React, { Component } from 'react'
import styled from 'styled-components'
import Input from 'components/Input'
import { Col, Row } from 'react-flexbox-grid'
import { Marginer } from 'components/Util'
import RadioGroup from 'components/SubscriptionRadioGroup'
import SelectInput from 'components/SelectInput'
import PostalInput from 'components/PostalInput'
import CheckInput from 'components/CheckInput'
import TariffSummary from 'components/TariffSummary'
import { generateMediaUrl } from 'utils'
import { TARIFF, TIER, POTENCY, CONTACT_HOUR, CYCLE, CONTACTS, DIRECT_DEBIT, BILLING_ADDRESS, ELETRONIC_BILLING } from './data'
import { MEDIA_BASE_URL, PAGE_URL, isEnterprise } from 'config'

import find from 'lodash/find'
import { hasPaidServices } from 'containers/TariffSubscribeModal/validations'
import VirtualizedSelect from 'react-virtualized-select'

const SimplePersonalPanel = ({ name, surname, nif, email, phone, onChange, reqMail, reqPhone }) => {
  const key = 'personal'
  return (
    <div>
      <Title>Dados pessoais</Title>
      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label='Primeiro nome *'
              type='text'
              value={name.value}
              className={name.valid ? `invalid` : 'valid'}
              onChange={(val) => onChange(key, 'name', val)}
            />
            <Error>{name.valid}</Error>
          </Col>
          <Col xs={6}>
            <Input
              label='Apelido *'
              type='text'
              value={surname.value}
              className={surname.valid && `invalid`}
              onChange={(val) => onChange(key, 'surname', val)}
            />
            <Error>{surname.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Title>Contactos</Title>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label={addRequiredIndicator(reqMail, 'Email')}
              type='email'
              value={email.value}
              className={email.valid && `invalid`}
              onChange={(val) => onChange(key, 'email', val)}
            />
            <Error>{email.valid}</Error>
          </Col>
          <Col xs={6}>
            <Input
              label={addRequiredIndicator(reqPhone, 'Telefone / Telemóvel')}
              type='text'
              value={phone.value}
              maxLength={9}
              onlyNumbers
              className={phone.valid && `invalid`}
              onChange={(val) => onChange(key, 'phone', val)}
            />
            <Error>{phone.valid}</Error>
          </Col>
        </Row>
      </Marginer>
    </div>
  )
}

/* eslint-disable camelcase */
const PersonalPanel = ({ name, surname, nif, email, phone, contact, contact_time, onChange, reqMail, reqPhone }) => {
  const key = 'personal'
  return (
    <div>
      <Title>Dados pessoais</Title>
      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label='Primeiro nome *'
              type='text'
              value={name.value}
              className={name.valid ? `invalid` : 'valid'}
              onChange={(val) => onChange(key, 'name', val)}
            />
            <Error>{name.valid}</Error>
          </Col>
          <Col xs={6}>
            <Input
              label='Apelido *'
              type='text'
              value={surname.value}
              className={surname.valid && `invalid`}
              onChange={(val) => onChange(key, 'surname', val)}
            />
            <Error>{surname.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label='NIF *'
              type='text'
              value={nif.value}
              maxLength={9}
              onlyNumbers
              className={nif.valid && `invalid`}
              onChange={(val) => onChange(key, 'nif', val)}
            />
            <Error>{nif.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Title>Contactos</Title>
      </Marginer>
      <Marginer top='0' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label={addRequiredIndicator(reqMail, 'Email')}
              type='email'
              value={email.value}
              className={email.valid && `invalid`}
              onChange={(val) => onChange(key, 'email', val)}
            />
            <Error>{email.valid}</Error>
          </Col>
          <Col xs={6}>
            <Input
              label={addRequiredIndicator(reqPhone, 'Telefone / Telemóvel')}
              type='text'
              value={phone.value}
              maxLength={9}
              onlyNumbers
              className={phone.valid && `invalid`}
              onChange={(val) => onChange(key, 'phone', val)}
            />
            <Error>{phone.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6} style={{ minHeight: '62px' }}>
            <RadioGroup
              label={CONTACTS.name}
              name={CONTACTS.fieldName}
              items={CONTACTS.values}
              default={contact.value}
              onClick={(val) => onChange(key, 'contact', val)}
            />
          </Col>
          {contact.value === 'p' &&
          <Col xs={6}>
            <SelectInput
              label={CONTACT_HOUR.name}
              items={CONTACT_HOUR.values}
              selected={contact_time}
              className={contact_time.valid && `invalid`}
              onChange={(val) => onChange(key, 'contact_time', val)}
          />
            <Error>{contact_time.valid}</Error>
          </Col>
          }
        </Row>
      </Marginer>
    </div>
  )
}

const EnterprisePanel = ({
  name,
  surname,
  nif,
  onChange,
  companyName,
  companyPhoneNumber,
  contact_time,
  contact,
  companyEmail,
  companyCae,
  caes,
  legalBi,
  email,
  phone,
  reqMail,
  reqPhone
}) => {
  const key = 'personal'
  return (
    <div>
      <Title>Dados da empresa</Title>
      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label='Nome da empresa *'
              type='text'
              value={companyName.value}
              className={companyName.valid ? `invalid` : 'valid'}
              onChange={(val) => onChange(key, 'companyName', val)}
            />
            <Error>{companyName.valid}</Error>
          </Col>

          <Col xs={6}>
            <Input
              label='NIPC/NIF empresa *'
              type='text'
              value={nif.value}
              maxLength={9}
              onlyNumbers
              className={nif.valid && `invalid`}
              onChange={(val) => onChange(key, 'nif', val)}
            />
            <Error>{nif.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label={addRequiredIndicator(reqMail, 'Email empresa')}
              type='email'
              value={companyEmail.value}
              className={companyEmail.valid && `invalid`}
              onChange={(val) => onChange(key, 'companyEmail', val)}
            />
            <Error>{companyEmail.valid}</Error>
          </Col>
          <Col xs={6}>
            <Input
              label={addRequiredIndicator(reqPhone, 'Telefone empresa')}
              type='text'
              value={companyPhoneNumber.value}
              maxLength={9}
              onlyNumbers
              className={companyPhoneNumber.valid && `invalid`}
              onChange={(val) => onChange(key, 'companyPhoneNumber', val)}
            />
            <Error>{companyPhoneNumber.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={12}>
            <CaeLabel>{`CAE`}</CaeLabel>
            <StyledSelectCae
              options={caes}
              placeholder={`CAE`}
              onChange={(val) => onChange(key, 'companyCae', val)}
              value={companyCae.value}
              disabled
            />
            <Error>{companyCae.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label='BI/CC do representante legal *'
              type='text'
              value={legalBi.value}
              maxLength={9}
              onlyNumbers
              className={legalBi.valid && `invalid`}
              onChange={(val) => onChange(key, 'legalBi', val)}
            />
            <Error>{legalBi.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label='Primeiro nome do representante legal  *'
              type='text'
              value={name.value}
              className={name.valid ? `invalid` : 'valid'}
              onChange={(val) => onChange(key, 'name', val)}
            />
            <Error>{name.valid}</Error>
          </Col>
          <Col xs={6}>
            <Input
              label='Apelido do representante legal *'
              type='text'
              value={surname.value}
              className={surname.valid && `invalid`}
              onChange={(val) => onChange(key, 'surname', val)}
            />
            <Error>{surname.valid}</Error>
          </Col>
        </Row>
      </Marginer>

      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label='Email contacto *'
              type='email'
              value={email.value}
              className={email.valid && `invalid`}
              onChange={(val) => onChange(key, 'email', val)}
            />
            <Error>{email.valid}</Error>
          </Col>
          <Col xs={6}>
            <Input
              label='Telefone / Telemóvel Contacto *'
              type='text'
              value={phone.value}
              maxLength={9}
              onlyNumbers
              className={phone.valid && `invalid`}
              onChange={(val) => onChange(key, 'phone', val)}
            />
            <Error>{phone.valid}</Error>
          </Col>
        </Row>
      </Marginer>

      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6} style={{ minHeight: '62px' }}>
            <RadioGroup
              label={CONTACTS.name}
              name={CONTACTS.fieldName}
              items={CONTACTS.values}
              default={contact.value}
              onClick={(val) => onChange(key, 'contact', val)}
            />
          </Col>
          {contact.value === 'p' &&
          <Col xs={6}>
            <SelectInput
              label={CONTACT_HOUR.name}
              items={CONTACT_HOUR.values}
              selected={contact_time}
              className={contact_time.valid && `invalid`}
              onChange={(val) => onChange(key, 'contact_time', val)}
          />
            <Error>{contact_time.valid}</Error>
          </Col>
          }
        </Row>
      </Marginer>
    </div>
  )
}

const BillingPanel = ({
  tariffAditionalInfo,
  getPostal,
  districts,
  municipalities,
  postalCode,
  postalExtension,
  street,
  door,
  floor,
  district,
  municipality,
  billingPostalCode,
  billingPostalExtension,
  billingStreet,
  billingDoor,
  billingFloor,
  billingDistrict,
  billingMunicipality,
  billingAddress,
  billingMunicipalities,
  electronicBilling,
  directDebit,
  onChange,
  loadingAddress,
  addressNotFound
}) => {
  const key = 'billing'
  return (
    <div>
      <Title>Morada do contrato</Title>
      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <PostalInput
              onClick={(postal) => getPostal({ ...postal, type: 'normal' })}
              code={postalCode.value}
              ext={postalExtension.value}
              changeCode={(val) => onChange(key, 'postalCode', val)}
              changeExt={(val) => onChange(key, 'postalExtension', val)}
              loading={loadingAddress}
          />
            <Error>{addressNotFound && `O Codigo-Postal não foi encontrado`}</Error>
            <Error>{postalCode.valid || postalExtension.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={12}>
            <Input
              label='Rua *'
              type='text'
              value={street.value}
              onChange={(val) => onChange(key, 'street', val)}
              className={street.valid ? `invalid` : 'valid'}
          />
            <Error>{street.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <Input
              label='Nº da porta *'
              type='text'
              value={door.value}
              onChange={(val) => onChange(key, 'door', val)}
              className={door.valid ? `invalid` : 'valid'}
          />
            <Error>{door.valid}</Error>
          </Col>
          <Col xs={6}>
            <Input
              label='Andar'
              type='text'
              value={floor.value}
              onChange={(val) => onChange(key, 'floor', val)}
          />
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <SelectInput
              label='Distrito *'
              items={districts && districts.map(dis => ({ label: dis.name, value: dis.id }))}
              placeholder={`Selecionar o distrito...`}
              onChange={(val) => onChange(key, 'district', val)}
              className={district.valid ? `invalid` : 'valid'}
              selected={district.value}
          />
            <Error>{district.valid}</Error>
          </Col>
          <Col xs={6}>
            <SelectInput
              label='Concelho *'
              items={municipalities && municipalities.map(dis => ({ label: dis.name, value: dis.id }))}
              placeholder={`Selecionar o distrito...`}
              onChange={(val) => onChange(key, 'municipality', val)}
              className={municipality.valid ? `invalid` : 'valid'}
              selected={municipality.value}
          />
            <Error>{municipality.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' bottom='0' right='0' left='0'>
        <Title>Morada da faturação</Title>
      </Marginer>
      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={12}>
            <RadioGroup
              label={BILLING_ADDRESS.name}
              name={BILLING_ADDRESS.fieldName}
              items={BILLING_ADDRESS.values}
              default={billingAddress.value}
              onClick={(val) => onChange(key, 'billingAddress', val)}
          />
          </Col>
        </Row>
      </Marginer>

      {/* TODO: Refactor */}
      {billingAddress.value === 'd' &&
      <Marginer>
        <Marginer top='16' bottom='0' right='0' left='0'>
          <Row>
            <Col xs={6}>
              <PostalInput
                onClick={(postal) => getPostal({ ...postal, type: 'billing' })}
                code={billingPostalCode.value}
                ext={billingPostalExtension.value}
                changeCode={(val) => onChange(key, 'billingPostalCode', val)}
                changeExt={(val) => onChange(key, 'billingPostalExtension', val)}
            />
              <Error>{billingPostalCode.valid}</Error>
            </Col>
          </Row>
        </Marginer>
        <Marginer top='16' bottom='0' right='0' left='0'>
          <Row>
            <Col xs={12}>
              <Input
                label='Rua *'
                type='text'
                value={billingStreet.value}
                onChange={(val) => onChange(key, 'billingStreet', val)}
                className={billingStreet.valid ? `invalid` : 'valid'}
            />
              <Error>{billingStreet.valid}</Error>
            </Col>
          </Row>
        </Marginer>
        <Marginer top='32' bottom='0' right='0' left='0'>
          <Row>
            <Col xs={6}>
              <Input
                label='Nº da porta  *'
                type='text'
                value={billingDoor.value}
                onChange={(val) => onChange(key, 'billingDoor', val)}
                className={billingDoor.valid ? `invalid` : 'valid'}
            />
              <Error>{billingDoor.valid}</Error>
            </Col>
            <Col xs={6}>
              <Input
                label='Andar'
                type='text'
                value={billingFloor.value}
                onChange={(val) => onChange(key, 'billingFloor', val)}
            />
            </Col>
          </Row>
        </Marginer>
        <Marginer top='32' bottom='0' right='0' left='0'>
          <Row>
            <Col xs={6}>
              <SelectInput
                label='Distrito *'
                items={districts && districts.map(dis => ({ label: dis.name, value: dis.id }))}
                placeholder='Selecionar o distrito...'
                onChange={(val) => onChange(key, 'billingDistrict', val)}
                className={billingDistrict.valid ? `invalid` : 'valid'}
                selected={billingDistrict.value}
            />
              <Error>{billingDistrict.valid}</Error>

            </Col>
            <Col xs={6}>
              <SelectInput
                label='Concelho *'
                items={billingMunicipalities && billingMunicipalities.map(mun => ({ label: mun.name, value: mun.id }))}
                placeholder='Selecionar o concelho...'
                onChange={(val) => onChange(key, 'billingMunicipality', val)}
                className={billingMunicipality.valid ? `invalid` : 'valid'}
                selected={billingMunicipality.value}
              />
              <Error>{billingMunicipality.valid}</Error>
            </Col>
          </Row>
        </Marginer>
      </Marginer>
      }

      <Marginer top='32' bottom='0' right='0' left='0'>
        <Title>Detalhes da faturação</Title>
      </Marginer>

      <Marginer top='16' bottom='0' right='0' left='0'>
        <Row>
          <Col xs={6}>
            <RadioGroup
              label={DIRECT_DEBIT.name}
              name={DIRECT_DEBIT.fieldName}
              items={DIRECT_DEBIT.values}
              default={directDebit.value}
              onClick={(val) => onChange(key, 'directDebit', val)}
              disabled={tariffAditionalInfo && tariffAditionalInfo.direct_debit}
          />
          </Col>
          <Col xs={6}>
            <RadioGroup
              label={ELETRONIC_BILLING.name}
              name={ELETRONIC_BILLING.fieldName}
              items={ELETRONIC_BILLING.values}
              default={electronicBilling.value}
              onClick={(val) => onChange(key, 'electronicBilling', val)}
              disabled={tariffAditionalInfo && tariffAditionalInfo.electronic_billing}
          />
          </Col>
        </Row>
      </Marginer>
    </div>
  )
}

const ElectricityPanel = ({ entity, userProfile, entities, currentEntity, cpe, potency, tariff, cycle, onChange }) => {
  const key = 'electric'
  const userCPE = userProfile.cpe

  if (userCPE && !cpe.value) {
    onChange(key, 'cpe', userCPE)
  }
  return (
    <div>
      <Title>Dados de fornecimento de eletricidade</Title>
      <Marginer top='16' right='0' left='0' bottom='0'>
        <Row>
          <Col xs={6}>
            <Label>Fornecedor</Label>
            <Logo src={`${MEDIA_BASE_URL}${entity.hi_res_logo}`} />
          </Col>
          <Col xs={6}>
            <Input
              label='CPE'
              type='text'
              placeholder={`Escreva o CPE...`}
              value={cpe.value}
              maxLength={20}
              onChange={(val) => onChange(key, 'cpe', val)}
            />
            {!cpe.valid && <InfoLabel>Verifique o código do ponto de entrega (CPE) na sua fatura. Tem o formato PT + 16 algarismos + 2 letras</InfoLabel>}
            <Error>{cpe.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' right='0' left='0' bottom='0'>
        <Row>
          <Col xs={6}>
            <SelectInput
              label={POTENCY.name}
              items={POTENCY.values}
              placeholder={`Selecionar a potência...`}
              onChange={(val) => onChange(key, 'potency', val)}
              selected={potency.value}
              disabled
            />
            <Error>{potency.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' right='0' left='0' bottom='0'>
        <Row>
          <Col xs={6}>
            <SelectInput
              label={TARIFF.name}
              items={TARIFF.values}
              placeholder={`Selecionar a tarifa...`}
              onChange={(val) => onChange(key, 'tariff', val)}
              selected={tariff.value}
              disabled
            />
            <Error>{tariff.valid}</Error>
          </Col>
          {tariff.value !== 's' &&
          <Col xs={6}>
            <SelectInput
              label={CYCLE.name}
              items={CYCLE.values}
              placeholder={`Selecionar o ciclo horário...`}
              onChange={(val) => onChange(key, 'cycle', val)}
              selected={cycle.value}
            />
            <Error>{cycle.valid}</Error>
          </Col>
          }
        </Row>
      </Marginer>
    </div>
  )
}

const GasPanel = ({ entity, userProfile, entities, cui, currentEntity, tier, onChange }) => {
  const key = 'gas'
  const userCUI = userProfile.cui
  
  if (userCUI && !cui.value) {
    onChange(key, 'cui', userCUI)
  }  
  return (
    <div>
      <Title>Dados de fornecimento de gás natural</Title>
      <Marginer top='16' right='0' left='0' bottom='0'>
        <Row>
          <Col xs={6}>
            <Label>Fornecedor</Label>
            <Logo src={`${MEDIA_BASE_URL}${entity.hi_res_logo}`} />
          </Col>
          <Col xs={6}>
            <Input
              label='CUI'
              placeholder={`Escreva o CUI...`}
              type='text'
              value={cui.value}
              maxLength={20}
              onChange={(val) => onChange(key, 'cui', val)}
          />
            {!cui.valid && <InfoLabel>Verifique o código universal da instalação (CUI) na sua fatura. Tem o formato PT + 16 algarismos + 2 letras</InfoLabel>}
            <Error>{cui.valid}</Error>
          </Col>
        </Row>
      </Marginer>
      <Marginer top='32' right='0' left='0' bottom='0'>
        <Row>
          <Col xs={6}>
            <SelectInput
              label={TIER.name}
              items={TIER.values}
              placeholder={`Selecione o escalão...`}
              onChange={(val) => onChange(key, 'tier', val)}
              selected={tier.value}
              disabled
          />
            <Error>{tier.valid}</Error>
          </Col>
        </Row>
      </Marginer>
    </div>
  )
}

const ConfirmationPanel = (props) => {
  const filterPersonal = Object.assign({}, props.labels.personal)
  if (props.entries.personal.contact.value !== 'p') {
    delete filterPersonal.contact_time
  }

  return (
    <div>
      <Row>
        <Col xs={6}>
          <Row>
            <Col xs={12}>
              <Title>Resumo dos dados de adesão ao tarifário</Title>
            </Col>
            <Col xs={12}>
              <Information
                labels={filterPersonal}
                entries={props.entries.personal}
                gasEntities={props.gasEntities}
                electricEntities={props.eletricEntities}
                caes={props.caes}
              />
              <Information
                labels={props.labels.billing}
                entries={props.entries.billing}
                gasEntities={props.gasEntities}
                electricEntities={props.eletricEntities}
                municipalities={props.municipalities}
                billingMunicipalities={props.billingMunicipalities}
                districts={props.districts}
              />
              {props.hasEletricity &&
              <Information
                labels={props.labels.electric}
                entries={props.entries.electric}
                gasEntities={props.gasEntities}
                electricEntities={props.eletricEntities}
              />
              }

              {props.hasGas &&
              <Information
                labels={props.labels.gas}
                entries={props.entries.gas}
                gasEntities={props.gasEntities}
                electricEntities={props.eletricEntities}
              />
              }
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <Row>
            <Col xs={12}>
              <Marginer top={0} left={0} bottom={32} right={0}>
                <Title>Fornecedor</Title>
                <Logo src={props.entity && generateMediaUrl(props.entity.hi_res_logo)} />
              </Marginer>
              <Title>Novo tarifário: {props.hasGas ? props.tariff.gasPriceList.designation : props.tariff.electricityPriceList.designation }</Title>
              <TariffSummary
                tariff={props.tariff}
                entries={props.entries}
                tariffInfo={props.tariffInfo}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Disclaimer>
        <DisclaimerTitle>Esclarecimento</DisclaimerTitle>
        {props.tariffInfo && hasPaidServices(props.tariffInfo.additional_services) &&
        <DisclaimerText red>
        Este tarifário apresenta fidelização e/ou serviços com custos adicionais
        </DisclaimerText>}
        <DisclaimerText>
          <ListBall />
          Os valores apresentados baseiam-se nos dados introduzidos e representam uma estimativa da sua fatura de energia para os próximos 12 meses e da poupança expectável face ao seu tarifário atual.
        </DisclaimerText>
        <DisclaimerText>
          <ListBall />
          Estes valores têm em consideração as condições de consumo de eletricidade e/ou gás natural inseridos e que se assumem corretos e atuais.
        </DisclaimerText>
        <DisclaimerText>
          <ListBall />
          O presente pedido de adesão não constitui uma proposta contratual, sendo esta uma responsabilidade do comercializador, que entrará em contacto consigo.
        </DisclaimerText>
        <DisclaimerText>
          <ListBall />
          O OLMC não pode ser responsabilizado por eventuais diferenças no valor de faturação e/ou consumos de eletricidade e gás natural que venham a ocorrer durante este período, nem por eventuais divergências entre as partes que possam decorrer do contrato celebrado na sequência de informação disponibilizada pelo Portal Poupa Energia.
        </DisclaimerText>
        <DisclaimerTitle>
          Em caso de dúvida contacte-nos através do 211 160 500.
        </DisclaimerTitle>
      </Disclaimer>
      <Row>
        <Col xs={12}>
          <CheckboxWrapper>
            <CheckInput
              value={props.entries.confirm.allowDataSharing.value}
              onClick={() => props.changeAllowDataSharing()}
            />
            <span>
              Concordo com os <TermsLink target='_blank' href={`${PAGE_URL}/termos-e-condicoes/`}>termos e condições</TermsLink> e autorizo o envio desta informação para o comercializador.
            </span>
          </CheckboxWrapper>
          <Error>{props.entries.confirm.allowDataSharing.valid}</Error>
        </Col>
      </Row>
    </div>)
}

const Information = (props) => (
  <Summary>
    {Object.keys(props.labels).map(key => {
      if (key === 'postal') {
        return (
          <InfoEntry key={key} >
            <EntryLabel>{props.labels[key]}</EntryLabel>
            <EntryText>{`${props.entries['postalCode'].value}-${props.entries['postalExtension'].value}`}</EntryText>
          </InfoEntry>
        )
      } else if (key === 'potency') {
        return (
          <InfoEntry key={key} >
            <EntryLabel>{props.labels[key]}</EntryLabel>
            <EntryText>{`${String(props.entries.potency.value).replace('.', ',')} kVA`}</EntryText>
          </InfoEntry>
        )
      } else if (key === 'cycle' && props.entries.tariff && props.entries.tariff.value === 's') {
        return null
      } else if (key === 'companyCae') {
        const cae = props.caes && props.caes.find(({ value }) => props.entries.companyCae.value === value)
        return (
          <InfoEntry key={key} >
            <EntryLabel>{props.labels[key]}</EntryLabel>
            <EntryText>{cae && cae.label}</EntryText>
          </InfoEntry>
        )
      } else {
        const value = props.entries[key].value
        const designations = props.entries[key].designation
        let realValue = value
        if (designations && designations.values) {
          realValue = find(designations.values, { value })

          if (realValue) {
            realValue = realValue.label
          }
        } else {
          if (designations === 'ee' && props.electricEntities) {
            realValue = find(props.electricEntities, { id: value })

            if (realValue) {
              realValue = realValue.designation
            }
          }

          if (designations === 'eg' && props.gasEntities) {
            realValue = find(props.gasEntities, { id: value })
            if (realValue) {
              realValue = realValue.designation
            }
          }

          if (designations === 'd' && props.districts) {
            realValue = find(props.districts, { id: value })
            if (realValue) {
              realValue = realValue.name
            }
          }

          if (designations === 'm' && props.municipalities) {
            realValue = find(props.municipalities, { id: value })
            if (realValue) {
              realValue = realValue.name
            }
          }

          if (designations === 'bm' && props.billingMunicipalities) {
            realValue = find(props.billingMunicipalities, { id: value })
            if (realValue) {
              realValue = realValue.name
            }
          }
        }
        if (realValue) {
          return (
            <InfoEntry key={key} >
              <EntryLabel>{props.labels[key]}</EntryLabel>
              <EntryText>{realValue}</EntryText>
            </InfoEntry>
          )
        } else {
          return null
        }
      }
    })}
  </Summary>
)

function addRequiredIndicator (condition, string) {
  return `${string} ${condition ? '*' : ''}`
}

class TariffAdhesion extends Component {
  constructor () {
    super()

    const entreperiseLabels = {
      companyName: 'Nome da empresa',
      companyCae: 'CAE',
      companyPhoneNumber: 'Telefone da empresa',
      companyEmail: 'Email da empresa',
      legalBi: 'BI/CC do representante legal',
      name: 'Primeiro nome',
      surname: 'Apelido',
      nif: 'NIPC/NIF empresa',
      contact: 'Meio de contacto preferêncial',
      contact_time: 'Em que período pretende ser contactado?',
      email: 'Email contacto',
      phone: 'Telefone / Telemóvel Contacto'
    }

    this.labels = {
      personal: isEnterprise ? entreperiseLabels : {
        name: 'Primeiro nome',
        surname: 'Apelido',
        nif: 'NIF',
        email: 'Email',
        phone: 'Telefone / Telemóvel',
        contact: 'Meio de contacto preferêncial',
        contact_time: 'Em que período pretende ser contactado?'
      },
      billing: {
        street: 'Rua',
        door: 'Nº da porta',
        floor: 'Andar',
        postal: 'Código postal',
        district: 'Distrito',
        municipality: 'Concelho',
        billingAddress: 'Morada de faturação',
        billingStreet: 'Rua de faturação',
        billingDoor: 'Nº da porta de faturação',
        billingFloor: 'Andar de faturação',
        billingPostalCode: 'Código postal de faturação',
        billingDistrict: 'Distrito de faturação',
        billingMunicipality: 'Concelho de faturação',

        directDebit: 'Débito direto',
        electronicBilling: 'Fatura eletrónica'
      },
      electric: {
        cpe: 'CPE',
        potency: 'Potência',
        tariff: 'Tarifa',
        cycle: 'Ciclo horário'
      },
      gas: {
        cui: 'CUI',
        tier: 'Escalão'
      }
    }
  }

  checkAllFields = () => {
    Object.keys(this.props.formData).forEach(key => {
      if (this.state[key].value === '') {
        return { index: this.keyToIndex(key), valid: false }
      }
    })

    return { valid: false }
  }

  keyToIndex (key) {
    switch (key) {
      case 'personal':
        return 0
      case 'billing':
        return 1
      case 'electric':
        return 2
      case 'gas':
        return 3
      default:
        return 0
    }
  }

  onSubmit () {
    this.props.onClick(this.checkAllFields())
  }

  render () {
    const { numberOfTabs,
      hasEletricity,
      hasGas,
      formData,
      districts,
      tariff,
      municipalities,
      billingMunicipalities,
      electricEntities,
      gasEntities,
      tariffInfo,
      onChange,
      getPostal,
      index,
      caes,
      loadingAddress,
      addressNotFound,
      isSimple,
      userProfile
    } = this.props

    const { subscription_requires_email, subscription_requires_phone } = tariffInfo.entity
    const gasTab = hasEletricity && hasGas ? 3 : 2
    const isEleContract = !!(tariffInfo && tariffInfo.pricelistadditionalinfo.electronic_contract)
    return (
      <Container>
        {index === 0 && !isEnterprise && isEleContract &&
          <SimplePersonalPanel
            {...formData.personal}
            onChange={onChange}
            reqMail={subscription_requires_email}
            reqPhone={subscription_requires_phone}
          />}
        {index === 0 && !isEnterprise && !isEleContract &&
          <PersonalPanel
            {...formData.personal}
            onChange={onChange}
            reqMail={subscription_requires_email}
            reqPhone={subscription_requires_phone}
          />
        }
        {index === 0 && isEnterprise &&
          <EnterprisePanel
            {...formData.personal}
            onChange={onChange}
            caes={caes}
            reqMail={subscription_requires_email}
            reqPhone={subscription_requires_phone}
          />
        }
        {index === 1 && tariffInfo && !isEleContract &&
          <BillingPanel
            {...formData.billing}
            getPostal={getPostal}
            tariffAditionalInfo={tariffInfo && tariffInfo.pricelistadditionalinfo}
            districts={districts}
            municipalities={municipalities}
            billingMunicipalities={billingMunicipalities}
            onChange={onChange}
            loadingAddress={loadingAddress}
            addressNotFound={addressNotFound}
          />}
        {index === 2 && hasEletricity && !isSimple && !isEleContract &&
          <ElectricityPanel
            {...formData.electric}
            userProfile={userProfile}
            entity={tariff.electricityPriceList.entity}
            entities={electricEntities}
            onChange={onChange}
          />}
        {index === gasTab && hasGas && !isSimple && !isEleContract &&
        <GasPanel
          {...formData.gas}
          userProfile={userProfile}
          entity={tariff.gasPriceList.entity}
          entities={gasEntities}
          onChange={onChange}
        />}
        {index === numberOfTabs - 1 &&
          <ConfirmationPanel
            tariff={tariff}
            entries={formData}
            labels={this.labels}
            getRef={this.props.finalRef}
            eletricEntities={electricEntities}
            gasEntities={gasEntities}
            entity={this.props.tariffInfo.entity}
            changeAllowDataSharing={() => onChange('confirm', 'allowDataSharing', !formData.confirm.allowDataSharing.value)}
            hasEletricity={hasEletricity}
            hasGas={hasGas}
            districts={districts}
            municipalities={municipalities}
            billingMunicipalities={billingMunicipalities}
            tariffInfo={this.props.tariffInfo}
            caes={caes}
          />}
      </Container>
    )
  }
}

const Container = styled.div`
  padding: 32px 0;
`

const Title = styled.h6`
  color: #93C13E;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  margin: 0;
`

const Summary = styled.div`
  border-bottom: 1px solid #DEDEDE;
  padding-bottom: 12px;
`

const InfoEntry = styled.div`
  display: flex;
  margin-top: 12px;
`

const EntryLabel = styled.span`
  color: #9C9C9C;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 45%;
  min-width: 45%;
`

const EntryText = styled.span`
  color: #3E3E3E;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
`

const CheckboxWrapper = styled.div`
  display: flex;
  margin-top: 20px;

  span {
    margin-right: 10px;
    color: #676767;
    font-family: Nunito;
    font-size: 14px;
    line-height: 18px;
  }
`

const Label = styled.div`
  display: block;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  width: 100%;
  color: #676767;
  font-family: Nunito;
  font-weight: 600;
  line-height: 14px;
`

const Logo = styled.img`
  max-height: 35px;
  display: block;
  margin-top: 10px;
`

const Error = styled.span`
  display: block;
  color: indianred;
  font-size: 12px;
  margin-top: 10px;
`

const InfoLabel = styled.span`
  font-size: 12px;
  color: #bcbbbb;

`

const Disclaimer = styled.div`
font-size: 10px;
`

const DisclaimerTitle = styled.span`
display: block;
font-weight: bold;
margin-bottom: 20px;
color: #8abb3f;
font-size: 10px;
`

const DisclaimerText = styled.div`
margin-bottom: 10px;
font-size: 10px;

${({ red }) => red && `
color: indianred;
`}
`

const ListBall = styled.div`
width: 10px;
height: 10px;
background: linear-gradient(270deg,#006736 0%,#93C13E 100%);
display: inline-block;
border-radius: 50%;
margin-right: 10px;
`

const StyledSelectCae = styled(VirtualizedSelect)`
width: 100%;

@media screen and (max-width: 768px) {
  width: 320px;
}
.is-focused {
  .Select-control {
    border: 1px solid #BABABA;
  }
}
> .Select-control {

  box-shadow: none !important;
  border: 1px solid #BABABA;
  border-color: #BABABA !important;
  border-radius: 0px;
  height: 50px;
  font-size: 14px;
  font-family: 'Nunito', 'Helvetica Neue', sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);

  .Select-placeholder {
    line-height: 48px;
  }
  .Select-input {
    height: 48px;
    line-height: 48px;
  }
  .Select-value {
    line-height: 48px !important;
    outline:none;
    text-align: left;
    padding-left: 16px;
    &:focus{
      outline:none;
    }
    &:blur {
      outline:none;
    }
  }
}
.VirtualizedSelectOption {
  overflow: hidden;
  text-align: left;
  white-space: nowrap;
  vertical-align: top;
  font-size: 14px;
  font-family: 'Nunito', 'Helvetica Neue', sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
  padding: 16px 15px 15px 16px;

  &:hover {
    background-color: #EFEFEF;
  }
}
.VirtualizedSelectFocusedOption {
  background-color: #EFEFEF;

}
.VirtualizedSelectSelectedOption {

  background-color: #EFEFEF;

  &:hover {
    background-color: #EFEFEF;
  }
}

`

const CaeLabel = styled.label`
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  width: 100%;
  display: block;
  font-family: 'Nunito';
  color: #676767;
  font-family: Nunito;
  font-weight: 600;
  line-height: 14px;
  margin-bottom: 10px;
`

const TermsLink = styled.a`
  color: #8abb3f;

  &:hover {
    color: #6e9532;
  }
`

export default TariffAdhesion



// WEBPACK FOOTER //
// ./src/components/TariffSubscribeForm/index.js